import YAML from 'yaml';
import type {
  ModuleConfig,
  SlidesConfig,
  AgentsConfig,
  AssessmentConfig,
  ReflectionConfig,
  FinalReflectionConfig,
} from './types';

export class ConfigLoader {
  private baseUrl: string;

  constructor(baseUrl: string = '/config/modules') {
    this.baseUrl = baseUrl;
  }

  async loadModuleConfig(moduleId: string): Promise<ModuleConfig> {
    const yaml = await this.fetchYAML(`${this.baseUrl}/${moduleId}/module.yaml`);
    return YAML.parse(yaml) as ModuleConfig;
  }

  async loadPartSlides(moduleId: string, partId: string): Promise<SlidesConfig> {
    const yaml = await this.fetchYAML(`${this.baseUrl}/${moduleId}/parts/${partId}/slides.yaml`);
    return YAML.parse(yaml) as SlidesConfig;
  }

  async loadPartAgents(moduleId: string, partId: string): Promise<AgentsConfig> {
    const yaml = await this.fetchYAML(`${this.baseUrl}/${moduleId}/parts/${partId}/agents.yaml`);
    return YAML.parse(yaml) as AgentsConfig;
  }

  async loadPartAssessment(moduleId: string, partId: string): Promise<AssessmentConfig> {
    const yaml = await this.fetchYAML(`${this.baseUrl}/${moduleId}/parts/${partId}/assessment.yaml`);
    return YAML.parse(yaml) as AssessmentConfig;
  }

  async loadPartReflection(moduleId: string, partId: string): Promise<ReflectionConfig> {
    const yaml = await this.fetchYAML(`${this.baseUrl}/${moduleId}/parts/${partId}/reflection.yaml`);
    return YAML.parse(yaml) as ReflectionConfig;
  }

  async loadFinalReflection(moduleId: string): Promise<FinalReflectionConfig> {
    const yaml = await this.fetchYAML(`${this.baseUrl}/${moduleId}/final-reflection.yaml`);
    return YAML.parse(yaml) as FinalReflectionConfig;
  }

  private async fetchYAML(path: string): Promise<string> {
    const response = await fetch(path);
    if (!response.ok) {
      throw new Error(`Failed to load config from ${path}: ${response.statusText}`);
    }
    return response.text();
  }
}

export const configLoader = new ConfigLoader();
